import { type SbStoriesParams, type SbStoryParams } from "../types"

export function getParams<TOptions extends SbStoryParams | SbStoriesParams>(
    preview: boolean,
    options?: TOptions
) {
    const params: Partial<TOptions> = {}

    if (preview || process.env.NEXT_PUBLIC_FF_UNPUBLISHED_STORIES === "1") {
        params.version = "draft"
        params.cv = Date.now()
    } else {
        params.version = "published"
    }

    return { ...params, ...options }
}
